import DownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import UpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import Button, { type ButtonProps } from "@mui/material/Button";
import { parseAsStringEnum, useQueryState } from "nuqs";

export interface QuerySortButtonProps extends ButtonProps {
  defaultDirection: "asc" | "desc";
  label?: string;
  ascendingLabel?: string;
  descendingLabel?: string;
  queryKey: string;
}

export function QuerySortButton({
  defaultDirection,
  label = "",
  ascendingLabel = "",
  descendingLabel = "",
  queryKey,
  ...rest
}: QuerySortButtonProps) {
  const [direction, setDirection] = useQueryState(
    queryKey,
    parseAsStringEnum(["asc", "desc"]).withDefault(defaultDirection)
  );

  const directionLabel = direction === "asc" ? ascendingLabel : descendingLabel;
  const Icon = direction === "asc" ? <UpIcon /> : <DownIcon />;
  function onClick() {
    setDirection((dir) => (dir === "asc" ? "desc" : "asc"));
  }
  return (
    <Button
      startIcon={Icon}
      onClick={onClick}
      {...rest}
      data-testid="query-sort-button"
    >
      {directionLabel ?? label}
    </Button>
  );
}
